import React from 'react';
import type { ExtraConfig } from '@gov-nx/core/app';
import type { PageCode } from '@gov-nx/module/page';
import { useDokladyContext } from '@gov-nx/module/page';
import { ContentLayout, ErrorStatusBanner, LayoutGap } from '@gov-nx/ui/web';
import { ProfileContentLayout } from '../profil-ROB/ProfileContentLayout';
import { IdentityDocumentList } from './IdentityDocumentList';
import { IdentityDocumentListSkeleton } from './IdentityDocumentListSkeleton';
import { OwnDocumentsList } from './vlastni-doklady/OwnDocumentsList';

type DocumentsViewProps =
	ExtraConfig['profileRoutes']['dokladyConfig']['documentsView'] & {
		navigation: React.ReactNode;
		code: PageCode;
	};

export const DocumentsView = ({
	navigation,
	code,
	...documentsViewConfig
}: DocumentsViewProps) => {
	const { controls } = useDokladyContext();

	if (controls.initialLoading) {
		return (
			<ContentLayout customClasses="pt-4!">
				{navigation}
				<IdentityDocumentListSkeleton />
			</ContentLayout>
		);
	}

	if (controls.initialError) {
		return (
			<ContentLayout customClasses="pt-4!">
				{navigation}
				<ErrorStatusBanner code={code} />
			</ContentLayout>
		);
	}

	return (
		<ProfileContentLayout {...documentsViewConfig.profileContentLayout}>
			{navigation}
			<LayoutGap gap="l">
				<IdentityDocumentList code={code} />
				<OwnDocumentsList code={code} />
			</LayoutGap>
		</ProfileContentLayout>
	);
};
